module.exports = __webpack_public_path__ + "img/canvas-evening-cool.83897f95.jpg";